import { ParallaxProvider, Parallax } from 'react-scroll-parallax';
import './Interests.scss';
import { useEffect, useState } from 'react';
import { handleViewport } from 'react-in-viewport';
import photo1 from '../img/Gallery/Disneyland-Paris-castle.webp';
import photo2 from '../img/Gallery/Disneyland-hotel.webp';
import photo3 from '../img/Gallery/Minnie-cake-pop.webp';
import photo4 from '../img/Gallery/Ferrero-Rocher-cake-2.webp';
import photo5 from '../img/Gallery/Chocolate-tart.webp';
import photo6 from '../img/Gallery/Cheesecake.webp';
import photo7 from '../img/Gallery/Hogwarts-castle.webp';
import photo8 from '../img/Gallery/Las-Vegas-sign.webp';
import photo9 from '../img/Gallery/Disneyland-ferris-wheel.webp';
import photo10 from '../img/Gallery/Echeveria-plant.webp';
import photo11 from '../img/Gallery/Succulent-collection.webp';
import photo12 from '../img/Gallery/Rainbow-cake.webp';

function MyInterests(props) {
  const images = {
    col1: [
      photo1,
      photo2,
      photo3
    ],
    col2: [
      photo4,
      photo5,
      photo6
    ],
    col3: [
      photo7,
      photo8,
      photo9
    ],
    col4: [
      photo10,
      photo11,
      photo12
    ]
  }

  const [isMobileView, setIsMobileView] = useState(false);
  const { inViewport, forwardedRef } = props;

  useEffect(() => {
    const handleResize = (event) => {
      if (window.innerWidth < 1024) {
        setIsMobileView(true);
      } else {
        setIsMobileView(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      handleResize();
      window.removeEventListener('resize', handleResize);
    };
  });

  return (
    <section className="interests" ref={forwardedRef}>
      <div className="anchor" id="interests"></div>
      {inViewport &&
        <div className="row">
          <div className="col-xs-12 center-xs">
            <h2>Interests</h2>
            <div className="card">
              <ParallaxProvider>
                <Parallax speed={10} className="col-1">
                  {images.col1.map(image =>
                    <div className="slow parallax-image">
                      <div style={{ backgroundImage: `url('${image}')` }}>
                      </div>
                    </div>
                  )}
                  {isMobileView && (
                    <>
                      {images.col3.map(image =>
                        <div className="slow parallax-image">
                          <div style={{ backgroundImage: `url('${image}')` }}>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </Parallax>
                <Parallax speed={-5} className="col-2">
                  {images.col2.map(image =>
                    <div className="slow parallax-image">
                      <div style={{ backgroundImage: `url('${image}')` }}>
                      </div>
                    </div>
                  )}
                  {isMobileView && (
                    <>
                      {images.col4.map(image =>
                        <div className="slow parallax-image">
                          <div style={{ backgroundImage: `url('${image}')` }}>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </Parallax>
                {!isMobileView && (
                  <>
                    <Parallax speed={15} className="col-3">
                      {images.col3.map(image =>
                        <div className="slow parallax-image">
                          <div style={{ backgroundImage: `url('${image}')` }}>
                          </div>
                        </div>
                      )}
                    </Parallax>
                    <Parallax speed={-10} className="col-4">
                      {images.col4.map(image =>
                        <div className="slow parallax-image">
                          <div style={{ backgroundImage: `url('${image}')` }}>
                          </div>
                        </div>
                      )}
                    </Parallax>
                  </>
                )}
              </ParallaxProvider>
            </div>
          </div>
        </div>
      }
    </section>
  )
}

const Interests = handleViewport(MyInterests, { rootMargin: '-1.0px' });

export default Interests;